module.exports = __webpack_public_path__ + "img/mobile-phones.be4eaf31.svg";